import { useEffect } from "react";

const highlights = [
  {
    icon: "ri-broadcast-line",
    title: "Live Streaming Host Management",
    description:
      "Full onboarding, training, and performance support for hosts across live streaming platforms.",
  },
  {
    icon: "ri-funds-line",
    title: "Creator Training & Monetization",
    description:
      "Hands-on coaching to help creators maximize earnings and build sustainable digital careers.",
  },
  {
    icon: "ri-palette-line",
    title: "Content Strategy & Branding",
    description:
      "Professional brand identity, profile optimization, and multi-platform content direction.",
  },
  {
    icon: "ri-global-line",
    title: "Multi-Platform Partnerships",
    description:
      "Active across social media, live streaming, and content platforms — always expanding our network.",
  },
];

export default function HighlightsSection() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.15 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bg-brand-dark py-24 md:py-32 section-divider">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16 reveal">
          <span className="inline-block text-gold text-xs font-sans font-semibold tracking-[0.3em] uppercase mb-4">
            What We Do
          </span>
          <h2 className="font-display font-bold text-white text-4xl md:text-5xl">
            Agency <span className="text-gradient-gold">Highlights</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {highlights.map((item, i) => (
            <div
              key={item.title}
              className={`reveal reveal-delay-${i + 1} card-gold bg-brand-black rounded-2xl p-8 flex flex-col items-start gap-5 group cursor-default`}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl border border-gold/30 bg-gold/5 group-hover:bg-gold/15 transition-colors duration-300">
                <i
                  className={`${item.icon} text-gold text-2xl group-hover:scale-110 transition-transform duration-300`}
                />
              </div>
              <div>
                <h3 className="text-white font-display font-bold text-lg mb-2 leading-tight">
                  {item.title}
                </h3>
                <div className="w-10 h-px bg-gold/40 mb-3" />
                <p className="text-white/55 font-sans text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
